import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import WorkBoxContext from './WorkBoxContext';
import { register, unregister } from './serviceWorker';

var WorkBoxProvider =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(WorkBoxProvider, _Component);

  function WorkBoxProvider() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isUpdateAvailable: false,
      isUpdateActivated: false
    };
    _this.timer = null;

    _this.setCheckUpdateTimer = function (registration) {
      var interval = _this.props.interval;
      _this.timer = setInterval(function () {
        registration.update();
      }, interval);
    };

    return _this;
  }

  var _proto = WorkBoxProvider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _this$props = this.props,
        serviceWorkerUrl = _this$props.serviceWorkerUrl,
        disabled = _this$props.disabled,
        onError = _this$props.onError;

    if (disabled) {
      unregister();
    } else {
      register({
        serviceWorkerUrl: serviceWorkerUrl,
        onRegister: this.setCheckUpdateTimer,
        onUpdate: function onUpdate() {
          return _this2.setState({
            isUpdateAvailable: true
          });
        },
        onActivate: function onActivate() {
          return _this2.setState({
            isUpdateAvailable: false,
            isUpdateActivated: true
          });
        },
        onError: onError
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  _proto.render = function render() {
    var children = this.props.children;
    var _this$state = this.state,
        isUpdateAvailable = _this$state.isUpdateAvailable,
        isUpdateActivated = _this$state.isUpdateActivated;
    return React.createElement(WorkBoxContext.Provider, {
      value: {
        isUpdateAvailable: isUpdateAvailable,
        isUpdateActivated: isUpdateActivated
      }
    }, children);
  };

  return WorkBoxProvider;
}(Component);

WorkBoxProvider.defaultProps = {
  disabled: process.env.NODE_ENV !== 'production',
  serviceWorkerUrl: "/service-worker.js",
  interval: 60 * 60 * 1000,
  // 1 hour
  onError: function onError(error) {
    return console.error('Error during service worker registration:', error);
  }
};
export default WorkBoxProvider;